<template>
    <div
      id="svgaCanvas"
      v-show="isPlayGift"
      class="svgaContainer"
      ref="canvas"
    ></div>
</template>

<script>
import SVGA from "svgaplayerweb";
import {mapGetters, mapState} from "vuex";
import {_code} from "@utils/constant";
export default {
  name: "SvgPlayer",
  data: function () {
    return {
      isPlayGift: false
    };
  },
  computed:{
    ...mapGetters(["live"])
  },
  mounted() {
    // 1. 定义处理函数，绑定 this
    this.handleSocketMessage = this.handleSocketMessage.bind(this);
    this.$store.commit('ADD_MESSAGE_LISTENER', this.handleSocketMessage);
  },
  methods: {
    handleSocketMessage(msg) {
      switch (msg.msgType) {
        case _code.SEND_GIFT: // 发送礼物
          let jsonData = JSON.parse(msg.data);
          // console.log('giftType',jsonData.giftType);
          const giftType =  jsonData.giftType;
          if (this.live.id === msg.liveId) {
            if(giftType === 'svga'){
              this.playSvg(jsonData.phoneSvgUrl);
            }
          }
          break;
      }
    },
    playSvg(svgaUrl) {
      var player = new SVGA.Player("#svgaCanvas");
      var parser = new SVGA.Parser("#svgaCanvas");
      // let svgaPath = '/svga/love_socket_app_1683626395814.svga'
      let that = this;
      that.isPlayGift = true;
      this.$nextTick(() => {
        //这里使用动态加载的方式，加载tableData返回的svga源（例如：http://a.svga)
        // console.log("svgaUrl" + svgaUrl);
        parser.load(svgaUrl, function (videoItem) {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            // console.log("播放结束");
            that.isPlayGift = false;
          });
          // player.clearsAfterStop = true //player有很多属性，根据需要设置
        });
      });
    },
  },
  beforeDestroy() {
    this.$store.commit('REMOVE_MESSAGE_LISTENER', this.handleSocketMessage);
  }
};
</script>

<style scoped>
.svgaContainer {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: #FDD; */
  /* z-index: 1000; */
}
</style>
